import { Controller } from "@hotwired/stimulus";
import walletService from "../services/WalletService";
import { clearSessionCompleted, isProductEntryPath } from "../sessionCompletion";
import { storage } from "../storageconstants";
import { debugLog } from "../utils";

export default class CheckoutController extends Controller {
  static values = {
    domain: Object,
    companyName: String,
    companyLightLogo: String,
    companyDarkLogo: String,
    code: String,
    session: String,
    thirdPartyWalletChangeHandler: false,
  };

  initialize() {
    this.cachedAddress = null;

    // Only reset on bare /{code} entry. Outcome / already-paid loads also mount
    // this controller and must keep the completed status for the Back guard.
    if (isProductEntryPath()) {
      clearSessionCompleted();
    }

    sessionStorage.setItem(storage.CODE, this.codeValue);
    sessionStorage.setItem(storage.DOMAIN, JSON.stringify(this.domainValue));
    sessionStorage.setItem(storage.SESSION, this.sessionValue);
    sessionStorage.setItem(storage.COMPANY_NAME, this.companyNameValue);

    this.watchAccounts = async (wallets) => {
      // When we are are checking wallet changes.
      if (this.thirdPartyWalletChangeHandlerValue) {
        debugLog("watchAccounts wallets", wallets);
        if (wallets.length !== 0) {
          try {
            this.showLoadingScreen("Connecting New Wallet")
            const currentAddress = walletService.getWalletAddress();

            // Prevent double invoking twice. 
            if (!currentAddress || this.cachedAddress === currentAddress) return;

            this.cachedAddress = currentAddress;

            const form = document.getElementById("thirdPartyWalletForm");
            form.action = "/select-third-party-wallet";
            document.getElementById("third_party_wallet_form_wallet_type").value = "WALLET_CONNECT";
            document.getElementById("third_party_wallet_form_address").value = currentAddress;
            const connectorInput = document.getElementById("third_party_wallet_form_connector_label");
            if (connectorInput) {
              connectorInput.value = walletService.getConnectedWalletLabel() || "";
            }
            form.requestSubmit();

            this.hideLoadingScreen()
          } catch (error) {
            console.error(error)
          }
        } else {
          this.cachedAddress = null;
        }
      }
    };

    this.boundWatchAccounts = this.watchAccounts.bind(this);

    document.addEventListener("turbo:before-fetch-request", event => {
      const { fetchOptions } = event.detail

      // fetchOptions is the same object Turbo will pass to fetch()
      // so you can mutate it in place.

      fetchOptions.headers["X-Requested-With"] = "Turbo";
      fetchOptions.headers["X-Session"] = this.sessionValue;
      fetchOptions.headers["X-Code"] = this.codeValue;
    });
  }

  keypressEnterEvent(e) {
    if (e.key !== "Enter") return;

    const checkoutButton = document.getElementsByClassName("step-button")[0];
    if (!checkoutButton) return;

    const pointerEvents = window.getComputedStyle(checkoutButton).pointerEvents;
    if (pointerEvents === "none") return;

    e.preventDefault();
    checkoutButton.click();
  }

  connect() {
    this.boundKeypressEnterEvent = this.keypressEnterEvent.bind(this);
    document.addEventListener("keydown", this.boundKeypressEnterEvent);
    walletService.onWalletChange(this.boundWatchAccounts);
  }

  showLoadingScreen(message="Please Wait") {
    this.dispatch("showLoadingScreen", { detail: { text: message } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }

  listenWalletChange() {
    // Allow reconnecting the same wallet address after a back-navigation/disconnect cycle.
    this.cachedAddress = null;
    this.thirdPartyWalletChangeHandlerValue = true;
  }

  stopListeningWalletChange() {
    this.cachedAddress = null;
    this.thirdPartyWalletChangeHandlerValue = false;
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeypressEnterEvent);
    walletService.removeWalletChangeListener(this.boundWatchAccounts);
  }
}
